/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useMsal } from "@azure/msal-react"
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import { siteHost, sitePath } from '../../assets/ts/api/api'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import { UserContext } from '../../store/user-context-provider'
import ActionButtons from '../buttons/action-buttons'
import './loginuser.css'

let popupTop: number
let xpositionvalue: any
let offsetLeftValue: number
let offsetTopValue: number
let elementHeightValue: number
let offsetWidthValue: number

const LoginUser = ({ me }: any) => {
  /***** Responsive Popup Code Start *****/
  const { accounts, instance } = useMsal()
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)
  const loginuser = useRef(null)
  const popupbtnRef = useRef(null)
  const [xpositionvalueupdate, setpopupwidthupdate] = useState('')
  const [popupheight, setpopupheight] = useState<any>()
  const [showActionPopups, setShowActionPopups] = useState({
    loginuser: false,
  })
  const [btnActionshowhide, setActionbtnshowhide] = useState({
    loginuser: false,
  })
  const handleLogout = () => {
    instance.logoutRedirect()
      .then(() => {
        console.log("Logged out successfully")
      })
      .catch((error) => {
        console.error("Logout error", error)
      })
  }
  
  useEffect(() => {
    setpopupheight(window.innerHeight - (offsetTopValue + 90))
    const popupwidthdata = popupbtnRef.current
      ? popupbtnRef.current.offsetWidth
      : 0
    if (popupwidthdata < xpositionvalue) {
      xpositionvalue = xpositionvalue - popupwidthdata
      setpopupwidthupdate(xpositionvalue)
    } else if (
      popupwidthdata > offsetLeftValue &&
      popupwidthdata < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xpositionvalue = offsetLeftValue
      setpopupwidthupdate(xpositionvalue)
    } else if (
      popupwidthdata > offsetLeftValue &&
      popupwidthdata > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xpositionvalue = 0
      setpopupwidthupdate(xpositionvalue)
    }
  }, [multiplePopup])
  const showhide = { ...btnActionshowhide }
  function popupCloseOpenFunctionality(
    type: any,
    value: number,
    top: number,
    xposition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    popupTop = top
    xpositionvalue = xposition
    offsetLeftValue = left
    offsetTopValue = top
    elementHeightValue = elementHeight
    offsetWidthValue = offsetWidth
    showhide.loginuser = false
    setActionbtnshowhide(showhide)
    if (type === multiplePopup) {
      setMultiplePopup()
    } else if (type) {
      setMultiplePopup(type)
    }
  }

  const formatShortName = (name: string) => {
    let shortName = ''
    const splitName = name.split(' ')

    splitName.splice(0, 2).forEach((word) => {
      shortName += word[0].toUpperCase()
    })

    return shortName
  }

  const clearCache = () => {
    localStorage.clear()
    sessionStorage.clear()
  }

  const handleSignOut = () => {
    clearCache()
    window.location.href = sitePath + '/signout-oidc'
  }


  return (
    <div className='loginuser p-relative'>
      <ActionButtons
        className={
          multiplePopup === 'loginuser'
            ? ' popup-arrow font-14 poppins-semibold  align-items-center text-center justify-content-center text-uppercase mx-2 p-0 POC-thumb title-color51'
            : 'font-14 poppins-semibold  align-items-center text-center justify-content-center text-uppercase mx-2 p-0 POC-thumb title-color51'
        }

        isClick='loginuser'
        label={formatShortName(me.persona)}
        name={formatShortName(me.persona)}
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}
        ref={loginuser}
        showHide={showActionPopups.loginuser}
        type='button'
      />
      {multiplePopup === 'loginuser' ? (
        <div
          className='popup p-0'
          ref={popupbtnRef}
          style={{
            maxHeight: popupheight,
            overflow: 'auto',
            position: 'absolute',
            top: popupTop + 8,
          }}
        >
          <div className='d-flex w-100  align-items-center py-2 px-3'>
            <div>
              <h2
                aria-label={siteHost}
                className=' font-12 text-uppercase Poppins-medium color-primary '
                tabIndex={0}
              >
                {defaultToEmptyString(siteHost)}
              </h2>
            </div>
            <div className='ms-auto'>
              <ActionButtons
                className='my-0 btn poppins-regular font-12 p-0 title-color50 w-100 text-nowrap'
                isClick='loginuser'
                label='Sign out'
                name='Sign out'
                popupCloseOpenFunctionality={handleLogout}
                ref={loginuser}
                showHide={showActionPopups.loginuser}
                type='button'
              />
            </div>
          </div>

          <div className='p-2'>

            <div className='d-flex'>
              <div className='POC-thumb m-0 me-2 align-items-center d-flex justify-content-center poppins-semibold font-14 color-primary'>{defaultToEmptyString(formatShortName(me.persona))}</div>
              <div>
                <p aria-label={me.persona} className='m-0 poppins-semibold font-12 title-color30 my-1' tabIndex={0} >
                  {defaultToEmptyString(me.persona)}</p>

                <p aria-label={me.email} className='m-0 d-flex align-items-center font-12 poppins-regular font-12 title-color19 breakword' tabIndex={0}>
                  {defaultToEmptyString(me.email)}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
export default LoginUser